import React from "react";
import ServiceDetail from "./ServiceDetail";
import BusinessCardsBanner from "../../Components/Assets/Business-Cards-Banner.png";

function BusinessCards() {
  return (
    <ServiceDetail
      eyebrow="Business Cards"
      title="Business Card Design Packages"
      description="Professional business card packages designed to give your brand a polished, memorable, and print-ready first impression."
      ctaText="Request Business Card Design"

      heroImage={BusinessCardsBanner}

      packages={[
        {
          name: "Basic Card",
          subtitle: "Simple professional design",
          price: 100,
          features: [
            "Single-sided business card design",
            "Print-ready PDF file",
            "PNG/JPG preview file",
            "1 revision",
            "Brand colors included",
          ],
        },
        {
          name: "Premium Card",
          subtitle: "Best for polished branding",
          price: 175,
          featured: true,
          features: [
            "Double-sided business card design",
            "Print-ready PDF file",
            "PNG/JPG preview file",
            "2 revisions",
            "QR code placement",
            "Brand-consistent layout",
          ],
        },
        {
          name: "Complete Card Package",
          subtitle: "Best for full professional setup",
          price: 300,
          features: [
            "Double-sided business card design",
            "Print-ready PDF file",
            "PNG/JPG preview file",
            "Unlimited revisions",
            "QR code placement",
            "Matching email signature design",
          ],
        },
      ]}
      process={[
        {
          title: "Details",
          text: "We collect your name, title, contact details, logo, and brand style.",
        },
        {
          title: "Design",
          text: "We create a clean business card layout that matches your brand.",
        },
        {
          title: "Deliver",
          text: "You receive print-ready files that can be sent directly to a printer.",
        },
      ]}
    />
  );
}

export default BusinessCards;